import axios from "axios";

import Config from "../../config";

const getActionListaFunilByClienteId = clienteId => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/funil/lista/${clienteId}`
    });
};

export default getActionListaFunilByClienteId;
